import type { Publisher } from '@kimuno/api-sdk/lib/types/responses/Text';
import immutable from 'object-path-immutable';

import { AsyncActionStatus } from '../actions/common.actionTypes';
import { FETCH_PUBLISHERS, type FetchPublishersAction } from '../actions/publishers.actionTypes';
import type { StoreItem } from '.';

type PublisherActionTypes = FetchPublishersAction;

export type PublisherState = StoreItem<Publisher[]>;

const initialState: PublisherState = {
	data: [],
	status: AsyncActionStatus.INITIAL,
};

// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature / existing call sites)
const publishers = (state = initialState, action: PublisherActionTypes) => {
	switch (action.type) {
		case FETCH_PUBLISHERS.START:
			return immutable(state).set('status', AsyncActionStatus.LOADING).value();
		case FETCH_PUBLISHERS.SUCCESS:
			return immutable(state)
				.set('data', action.result)
				.set('status', AsyncActionStatus.READY)
				.value();
		case FETCH_PUBLISHERS.ERROR:
			return immutable(state).set('status', AsyncActionStatus.ERROR).value();
		default:
			return state;
	}
};

export default publishers;
